/**
 * The compact toolbar used by every rich-text field in the observations tab.
 * Separators keep related controls visually grouped without adding extra tools.
 */
export const OBSERVATION_EDITOR_BUTTONS = Object.freeze([
  "bold",
  "italic",
  "underline",
  "|",
  "font",
  "fontsize",
  "|",
  "align",
]);

export const createObservationEditorConfig = ({
  placeholderText,
  readOnly,
}) => ({
  readonly: readOnly,
  autofocus: false,
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  defaultActionOnPaste: "insert_only_text",
  disablePlugins: readOnly
    ? ["source"]
    : [
        "markdown",
        "orderedlist",
        "unorderedlist",
        "ol",
        "ul",
        "indent",
        "paste-from-word",
      ],
  buttons: OBSERVATION_EDITOR_BUTTONS,
  buttonsMD: OBSERVATION_EDITOR_BUTTONS,
  buttonsSM: OBSERVATION_EDITOR_BUTTONS,
  buttonsXS: OBSERVATION_EDITOR_BUTTONS,
  toolbarAdaptive: false,
  toolbarButtonSize: "small",
  removeButtons:
    "ul,ol,indent,outdent,eraser,strikethrough,subscript,superscript,brush,link,hr",
  placeholder: placeholderText,
  enter: "DIV",
  style: {
    fontFamily: '"Rubik", sans-serif',
    fontWeight: 400,
  },
});
